// Shared export-status pill (dashboard + workbook overview).

const STATUS_STYLES: Record<string, string> = {
  done: "bg-emerald-100 text-emerald-700 dark:bg-emerald-950/50 dark:text-emerald-300",
  running: "bg-blue-100 text-blue-700 dark:bg-blue-950/50 dark:text-blue-300",
  queued: "bg-zinc-100 text-zinc-600 dark:bg-surface-2 dark:text-zinc-400",
  error: "bg-red-100 text-red-700 dark:bg-red-950/50 dark:text-red-300",
  cancelled: "bg-amber-100 text-amber-700 dark:bg-amber-950/50 dark:text-amber-300",
};

export function ExportStatusBadge({ status }: { status: string }) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES.queued;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium ${style}`}
    >
      {status}
    </span>
  );
}
